export default __webpack_public_path__ + "static/media/Okaygologos.9efd4daa.svg";